// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gift-page-container {
  padding: 0 var(--spacing-regular);
  margin-bottom: var(--spacing-regular);
}
.gift-page-container .gift-information {
  padding: var(--spacing-small);
  display: flex;
  width: 100%;
  align-items: center;
  border-top: 8px solid #FFBE1E;
  border-radius: 10px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  box-sizing: border-box;
}
.gift-page-container .gift-information .information-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
@media screen and (max-width: 420px) {
  .gift-page-container {
    padding: 0 var(--spacing-regular);
  }
  .gift-page-container .form-container {
    padding: var(--spacing-small) var(--spacing-extra-small);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
    border-radius: var(--border-radius-primary);
  }
  .gift-page-container .gift-submit-button {
    width: 100%;
  }
  .gift-page-container .gift-submit-button .gift-submit-button-text {
    font-size: var(--font-medium);
    color: var(--color-button-text);
  }
}
.gift-banner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 190px;
  border-radius: var(--spacing-small);
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Services/background-banner-syngenta-min.png');
  background-size: cover;
  background-repeat: no-repeat;
}
@media screen and (max-width: 992px) {
  .gift-banner {
    font-size: var(--font-medium);
    flex-direction: column;
    height: 250px;
  }
}
.gift-banner-text-container {
  display: flex;
  flex-direction: column;
  margin-left: var(--spacing-big);
}
.gift-banner-text-container .banner-title {
  font-size: 30px;
  font-weight: 600;
  color: var(--color-white);
  font-family: var(--font-family);
  margin-right: 20px;
}
.gift-banner-text-container .banner-subtitle {
  font-size: var(--font-giant);
  font-style: normal;
  font-weight: 300;
  line-height: 22px !important;
  color: var(--color-white);
}
@media screen and (max-width: 411px) {
  .gift-banner-text-container .banner-title {
    font-size: 22px;
  }
  .gift-banner-text-container .banner-subtitle {
    font-size: 13px;
    line-height: 18px;
  }
}
@media screen and (min-width: 412px) and (max-width: 500px) {
  .gift-banner-text-container .banner-title {
    font-size: 26px;
  }
  .gift-banner-text-container .banner-subtitle {
    font-size: 16px;
    line-height: 18px;
  }
}
@media screen and (min-width: 501px) and (max-width: 767px) {
  .gift-banner-text-container .banner-title {
    font-size: 28px;
  }
  .gift-banner-text-container .banner-subtitle {
    font-size: 18px;
    line-height: 16px;
  }
}
.banner-button-container {
  margin-left: var(--spacing-big);
  display: flex;
}
.banner-button-container .banner-button {
  background-color: var(--color-white) !important;
}
.banner-button-container .banner-button .banner-button-text {
  font-size: var(--font-medium);
  color: var(--color-button-text);
}
@media screen and (max-width: 992px) {
  .banner-button-container {
    margin-left: 0;
    margin-top: 60px;
  }
}
.bigger-fonts {
  font-size: var(--font-big);
  color: var(--color-neutral-dark);
  line-height: var(--font-paragraph-line);
  font-family: var(--font-family);
  font-weight: 600;
}
.description-container {
  display: flex;
  align-items: center;
}
.description-container .description-image {
  object-fit: contain;
  margin-right: var(--spacing-big);
}
.description-container .box-image-gift {
  width: 107px;
  height: 107px;
  background-color: var(--color-white);
  border-radius: 50%;
}
.description-container .box-image-gift img {
  width: 87px;
  height: 79px;
  object-fit: contain;
}
.description-container .description-product-name {
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark);
  line-height: var(--spacing-regular);
  font-family: var(--font-family);
  font-weight: 600;
  display: flex;
  max-width: 70%;
  margin-left: var(--spacing-regular);
}
@media screen and (max-width: 480px) {
  .description-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .description-container .description-image {
    margin-right: 0;
    margin-bottom: var(--spacing-big);
  }
  .description-container .description-product-name {
    max-width: 100%;
    margin-left: 0;
    margin-top: var(--spacing-regular);
  }
}
.general-caracteristics-container {
  border: var(--border-width) solid var(--color-neutral-light);
  padding: var(--spacing-regular) var(--spacing-small);
  border-radius: var(--border-radius-primary);
  margin-top: var(--spacing-regular);
  margin-bottom: var(--spacing-regular);
}
.general-caracteristics-container .accordion-header {
  margin-bottom: 0;
}
.general-caracteristics-container .accordion-header > span {
  font-size: var(--font-medium);
  color: var(--color-neutral-dark);
  line-height: var(--spacing-regular);
  font-family: var(--font-family);
  font-weight: 600;
}
.general-caracteristics-container .accordion-header.active > .accordion-default {
  margin-bottom: var(--spacing-regular);
}
.general-caracteristics-container .accordion-content.active {
  box-sizing: border-box;
  padding-top: var(--spacing-regular);
  border-top: var(--border-width) solid var(--color-neutral-light);
}
@media screen and (max-width: 480px) {
  .col-responsive-spacing {
    margin-top: var(--spacing-small);
  }
}
.finalization-modal {
  display: flex;
}
.finalization-modal .redeem-information {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: var(--spacing-small);
  align-items: flex-start;
}
.finalization-modal .redeem-information .redeem-title {
  font-size: var(--font-paragraph);
  color: var(--color-neutral-dark-darker);
  line-height: var(--font-paragraph-line);
  font-family: var(--font-family);
  font-weight: 600;
  margin-bottom: var(--spacing-small);
}
.finalization-modal .redeem-information .date-container {
  width: 100%;
  display: flex;
}
@media screen and (max-width: 480px) {
  .finalization-modal .redeem-information .date-container {
    flex-direction: column;
    align-items: flex-start;
  }
}
.finalization-modal .redeem-information .date-container .date-title {
  margin-right: var(--spacing-extra-small);
}
.input-state-redeem-gift {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.input-state-redeem-gift div.vert-template-marketplace.vert-select {
  height: 100%;
}
.gift-description-accordion .accordion-content.active {
  height: auto !important;
}
.carousel-gift {
  width: 100%;
}
@media screen and (max-width: 768px) {
  .carousel-gift {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GiftBanner/GiftStyles.less"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,qCAAA;AACJ;AAHA;EAKQ,6BAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gDAAA;EAEA,sBAAA;AAAR;AAbA;EAgBY,gBAAA;EACA,eAAA;EACA,iBAAA;AAAZ;AAII;EAAA;IACI,iCAAA;EADN;EAAE;IAIQ,wDAAA;IACA,gDAAA;IACA,2CAAA;EADV;EALE;IAUQ,WAAA;EAFV;EARE;IAaY,6BAAA;IACA,+BAAA;EAFd;AACF;AAOA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EAEA,mCAAA;EAEA,yKAAA;EACA,sBAAA;EACA,4BAAA;AAPJ;AAWI;EAAA;IACI,6BAAA;IACA,sBAAA;IACA,aAAA;EARN;AACF;AAWA;EACI,aAAA;EACA,sBAAA;EACA,+BAAA;AATJ;AAMA;EAMQ,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;AATR;AADA;EAcQ,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;AAVR;AAaI;EAAA;IAEQ,eAAA;EAXV;EASE;IAMQ,eAAA;IACA,iBAAA;EAZV;AACF;AAeI;EAAA;IAEQ,eAAA;EAbV;EAWE;IAMQ,eAAA;IACA,iBAAA;EAdV;AACF;AAiBI;EAAA;IAEQ,eAAA;EAfV;EAaE;IAMQ,eAAA;IACA,iBAAA;EAhBV;AACF;AAsBA;EACI,+BAAA;EACA,aAAA;AApBJ;AAkBA;EAKQ,+CAAA;AApBR;AAeA;EAQY,6BAAA;EACA,+BAAA;AApBZ;AAwBI;EAAA;IACI,cAAA;IACA,gBAAA;EArBN;AACF;AAwBA;EACI,0BAAA;EACA,gCAAA;EACA,uCAAA;EACA,+BAAA;EACA,gBAAA;AAtBJ;AAyBA;EACI,aAAA;EACA,mBAAA;AAvBJ;AAqBA;EAKQ,mBAAA;EACA,gCAAA;AAvBR;AAiBA;EASQ,YAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;AAvBR;AAWA;EAeY,WAAA;EACA,YAAA;EACA,mBAAA;AAvBZ;AAMA;EAsBQ,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,mCAAA;AAzBR;AA4BI;EAAA;IACI,sBAAA;IACA,uBAAA;EAzBN;EAuBE;IAKQ,eAAA;IACA,iCAAA;EAzBV;EAmBE;IAUQ,eAAA;IACA,cAAA;IACA,kCAAA;EA1BV;AACF;AA8BA;EACI,4DAAA;EACA,oDAAA;EACA,2CAAA;EACA,kCAAA;EACA,qCAAA;AA5BJ;AAuBA;EAQQ,gBAAA;AA5BR;AAoBA;EAWY,6BAAA;EACA,gCAAA;EACA,mCAAA;EACA,+BAAA;EACA,gBAAA;AA5BZ;AAaA;EAqBY,qCAAA;AA/BZ;AAUA;EA0BQ,sBAAA;EACA,mCAAA;EACA,gEAAA;AAjCR;AAsCI;EAAA;IACI,gCAAA;EAnCN;AACF;AAsCA;EACI,aAAA;AApCJ;AAmCA;EAIQ,aAAA;EACA,sBAAA;EACA,OAAA;EACA,iCAAA;EACA,uBAAA;AApCR;AA4BA;EAWY,gCAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,gBAAA;EACA,mCAAA;AApCZ;AAoBA;EAoBY,WAAA;EACA,aAAA;AArCZ;AAuCY;EAAA;IACI,sBAAA;IACA,uBAAA;EApCd;AACF;AAUA;EA6BgB,wCAAA;AApChB;AA0CA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAxCJ;AAqCA;EAMQ,YAAA;AAxCR;AAgDQ;EACI,uBAAA;AA9CZ;AAmDA;EACI,WAAA;AAjDJ;AAoDA;EACI;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAlDF;AACF","sourcesContent":[".gift-page-container {\n    padding: 0 var(--spacing-regular);\n    margin-bottom: var(--spacing-regular);\n\n    .gift-information {\n        padding: var(--spacing-small);\n        display: flex;\n        width: 100%;\n        align-items: center;\n        border-top: 8px solid #FFBE1E;\n        border-radius: 10px;\n        box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n\n        box-sizing: border-box;\n\n        .information-text {\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 20px;\n        }\n    }\n\n    @media screen and (max-width: 420px) {\n        padding: 0 var(--spacing-regular);\n\n        .form-container {\n            padding: var(--spacing-small) var(--spacing-extra-small);\n            box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n            border-radius: var(--border-radius-primary);\n        }\n\n        .gift-submit-button {\n            width: 100%;\n\n            .gift-submit-button-text {\n                font-size: var(--font-medium);\n                color: var(--color-button-text);\n            }\n        }\n    }\n}\n\n.gift-banner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 190px;\n\n    border-radius: var(--spacing-small);\n\n    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://vertice-ds.s3.amazonaws.com/Assets/Images/Services/background-banner-syngenta-min.png');\n    background-size: cover;\n    background-repeat: no-repeat;\n\n    // background-attachment: fixed;\n\n    @media screen and (max-width: 992px) {\n        font-size: var(--font-medium);\n        flex-direction: column;\n        height: 250px;\n    }\n}\n\n.gift-banner-text-container {\n    display: flex;\n    flex-direction: column;\n    margin-left: var(--spacing-big);\n\n    .banner-title {\n        font-size: 30px;\n        font-weight: 600;\n        color: var(--color-white);\n        font-family: var(--font-family);\n        margin-right: 20px;\n    }\n\n    .banner-subtitle {\n        font-size: var(--font-giant);\n        font-style: normal;\n        font-weight: 300;\n        line-height: 22px !important;\n        color: var(--color-white);\n    }\n\n    @media screen and (max-width: 411px) {\n        .banner-title {\n            font-size: 22px;\n        }\n\n        .banner-subtitle {\n            font-size: 13px;\n            line-height: 18px;\n        }\n    }\n\n    @media screen and (min-width: 412px) and (max-width: 500px) {\n        .banner-title {\n            font-size: 26px;\n        }\n\n        .banner-subtitle {\n            font-size: 16px;\n            line-height: 18px;\n        }\n    }\n\n    @media screen and (min-width: 501px) and (max-width: 767px) {\n        .banner-title {\n            font-size: 28px;\n        }\n\n        .banner-subtitle {\n            font-size: 18px;\n            line-height: 16px;\n        }\n    }\n}\n\n\n\n.banner-button-container {\n    margin-left: var(--spacing-big);\n    display: flex;\n\n    .banner-button {\n        background-color: var(--color-white) !important;\n\n        .banner-button-text {\n            font-size: var(--font-medium);\n            color: var(--color-button-text);\n        }\n    }\n\n    @media screen and (max-width: 992px) {\n        margin-left: 0;\n        margin-top: 60px;\n    }\n}\n\n.bigger-fonts {\n    font-size: var(--font-big);\n    color: var(--color-neutral-dark);\n    line-height: var(--font-paragraph-line);\n    font-family: var(--font-family);\n    font-weight: 600;\n}\n\n.description-container {\n    display: flex;\n    align-items: center;\n\n    .description-image {\n        object-fit: contain;\n        margin-right: var(--spacing-big);\n    }\n    .box-image-gift{\n        width: 107px;\n        height:107px;\n        background-color: var(--color-white);\n        border-radius: 50%;\n\n        img{\n            width: 87px;\n            height: 79px;\n            object-fit: contain;\n        }\n    }\n\n    .description-product-name {\n        font-size: var(--font-paragraph);\n        color: var(--color-neutral-dark);\n        line-height: var(--spacing-regular);\n        font-family: var(--font-family);\n        font-weight: 600;\n        display: flex;\n        max-width: 70%;\n        margin-left: var(--spacing-regular);\n    }\n\n    @media screen and (max-width: 480px) {\n        flex-direction: column;\n        align-items: flex-start;\n\n        .description-image {\n            margin-right: 0;\n            margin-bottom: var(--spacing-big);\n        }\n\n        .description-product-name {\n            max-width: 100%;\n            margin-left: 0;\n            margin-top: var(--spacing-regular);\n        }\n    }\n}\n\n.general-caracteristics-container {\n    border: var(--border-width) solid var(--color-neutral-light);\n    padding: var(--spacing-regular) var(--spacing-small);\n    border-radius: var(--border-radius-primary);\n    margin-top: var(--spacing-regular);\n    margin-bottom: var(--spacing-regular);\n\n    .accordion-header {\n        margin-bottom: 0;\n\n        >span {\n            font-size: var(--font-medium);\n            color: var(--color-neutral-dark);\n            line-height: var(--spacing-regular);\n            font-family: var(--font-family);\n            font-weight: 600;\n        }\n    }\n\n    .accordion-header.active {\n        >.accordion-default {\n            margin-bottom: var(--spacing-regular);\n        }\n    }\n\n    .accordion-content.active {\n        box-sizing: border-box;\n        padding-top: var(--spacing-regular);\n        border-top: var(--border-width) solid var(--color-neutral-light);\n    }\n}\n\n.col-responsive-spacing {\n    @media screen and (max-width: 480px) {\n        margin-top: var(--spacing-small);\n    }\n}\n\n.finalization-modal {\n    display: flex;\n\n    .redeem-information {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        margin-left: var(--spacing-small);\n        align-items: flex-start;\n\n        .redeem-title {\n            font-size: var(--font-paragraph);\n            color: var(--color-neutral-dark-darker);\n            line-height: var(--font-paragraph-line);\n            font-family: var(--font-family);\n            font-weight: 600;\n            margin-bottom: var(--spacing-small);\n        }\n\n        .date-container {\n            width: 100%;\n            display: flex;\n\n            @media screen and (max-width: 480px) {\n                flex-direction: column;\n                align-items: flex-start;\n            }\n\n            .date-title {\n                margin-right: var(--spacing-extra-small);\n            }\n        }\n    }\n}\n\n.input-state-redeem-gift {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    div.vert-template-marketplace.vert-select {\n        height: 100%;\n    }\n}\n\n\n\n.gift-description-accordion {\n    .accordion-content {\n        &.active {\n            height: auto !important;\n        }\n    }\n}\n\n.carousel-gift{\n    width: 100%;\n}\n\n@media screen  and (max-width: 768px){\n    .carousel-gift{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    } \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
